export default __webpack_public_path__ + "static/media/ill-no-data.e0f06fd3.svg";